import MarketingImage from '@/components/landing/MarketingImage';
import React from 'react';
const clipboardRemoveIcon = '/images/marketing/landing-about-problems-clipboard-remove.svg';
const documentTextIcon = '/images/marketing/landing-about-problems-document-text.svg';
const hiddenCeilingIcon = '/images/marketing/landing-about-problems-hidden-ceiling.svg';
const refreshCircleIcon = '/images/marketing/landing-about-problems-refresh-circle.svg';
import styles from './MissionSection.module.css';

const aboutCards = [
  {
    icon: clipboardRemoveIcon,
    tone: 'blue',
    title: 'The intake gap',
    description: 'Information arrives in fragments. You spend the first session catching up instead of consulting.'
  },
  {
    icon: documentTextIcon,
    tone: 'blue',
    title: 'The unread reports',
    description: 'Lab results open in a tab and stay there. Patterns get missed. Context gets lost.'
  },
  {
    icon: refreshCircleIcon,
    tone: 'teal',
    title: 'The repetition',
    description: 'Building the same meal plan, the same recommendations, the same follow-up template. Again.'
  },
  {
    icon: hiddenCeilingIcon,
    tone: 'gold',
    title: 'The hidden ceiling',
    description: "Your caseload grows. Your hours don't. Quality becomes a trade-off."
  }
];

// LANDING PAGE COMPONENT: MissionSection
// This component can be easily separated for launching the landing page first
const MissionSection = () => {
  return (
    <div className={styles.aboutSection}>
      <div className={styles.aboutCanvas}>
        <div className={styles.aboutInner}>
          <div className={styles.copyColumn}>
            <h2 className={styles.title}>
              <span className={styles.titleLine}>What makes scaling</span>
              <br />
              <span className={styles.titleLine}>so difficult?</span>
            </h2>
            <p className={styles.subtitle}>
              More clients shouldn't mean more chaos.
              <br />
              But it often does.
            </p>
          </div>

          <div className={styles.cardGrid}>
            {aboutCards.map(card => {
              return (
                <article key={card.title} className={styles.aboutCard}>
                  <div className={`${styles.iconShell} ${styles[card.tone]}`}>
                    <MarketingImage loading="lazy" src={card.icon} alt="" className={styles.iconImage} aria-hidden="true" />
                  </div>
                  <div className={styles.cardContent}>
                    <h3 className={styles.cardTitle}>{card.title}</h3>
                    <p className={styles.cardDescription}>{card.description}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionSection;
